import { queryClient } from "./../../../Api/queryClient";
// GET_OFFERS_LIST

import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import axiosInstance from "../../../Api/axiosInstance";
import { useQueryClient } from "@tanstack/react-query";

export const getOfferList = async (params?: any) => {
  const response = await axiosInstance.get(
    `${API_ENDPOINTS.OFFERS.GET_OFFERS_LIST}`,
    { params: params }
  );

  console.log("🚀 ~ OfferRepo.ts:12 ~ getOfferList ~ response:", response);

  return response?.data;
};

export const getSingleOfferList = async (
  id?: string | number,
  params?: any
) => {
  const response = await axiosInstance.get(
    `${API_ENDPOINTS.OFFERS.GET_SINGLE_OFFERS_LIST}/${id}`,
    { params: params }
  );

  console.log("🚀 ~ OfferRepo.ts:12 ~ getOfferList ~ response:", response);

  return response?.data;
};

// ADD_OFFER
export const addOffer = async (body?: any) => {
  return axiosInstance.post(API_ENDPOINTS.OFFERS.ADD_OFFER, body);
};
export const updateOffer = async (id?: string | number, body?: any) => {
  return axiosInstance.put(`${API_ENDPOINTS.OFFERS.UPDATE_OFFER}/${id}`, body);
};
